import { Button, Form, message, Pagination, PaginationProps, Space, Table, TableProps, Typography } from "antd";
import { useEffect, useState } from "react";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";
import VocsModal from "src/components/Modal";
import {
  AreaSeries,
  AreaSeriesDto,
  DataTableComBySeries,
  Emission,
  initComBySeriesFugitive,
  SettingComBySeries,
} from "src/entity/settings/fugitive";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { componentPalette } from "src/theme/component-palette";
import { canEditTable } from "../PermissionCheck/PermissionCheck";
import { PlusCircleOutlined } from "@ant-design/icons";
import { fugitiveStore } from "src/stores/fugitive-store";
import { useShallow } from "zustand/react/shallow";
import FugitiveComBySeriesModal from "./FugitiveComBySeriesModal";
import { companyStore } from "src/stores/company-store";
import { profileStore } from "src/stores/profile-store";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { createComBySeriesFugitive, deleteComBySeriesFugitive, updateComBySeriesFugitive } from "src/services/settings.service";
import { formatNumberWithFillZero } from "src/utils/process-number";

type OnChange = NonNullable<TableProps<any>["onChange"]>;
type Filters = Parameters<OnChange>[1];
const { Text } = Typography;

const FugitiveComBySeriesTable = () => {
  const profile = profileStore(useShallow((state) => state.profile));
  const companies = profile?.company ?? [];
  const [messageApi, contextHolder] = message.useMessage();
  const [mode, setMode] = useState<"insert" | "update">("insert");
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState<Filters>({});
  const [loading, setLoading] = useState(false);
  const { permissions } = useNavigationMenu();
  const pageSize = 10;
  const [current, setCurrent] = useState(1);
  const [form] = Form.useForm();
  const [selectedId, setSelectedId] = useState<string>("");
  const [dataTable, setDataTable] = useState<DataTableComBySeries[]>([]);
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);

  const comBySeriesFugitive = fugitiveStore(useShallow((state) => state.comBySeriesFugitive));
  const totalComBySeriesFugitive = fugitiveStore(useShallow((state) => state.totalComBySeriesFugitive));
  const getComBySeriesFugitive = fugitiveStore(useShallow((state) => state.getComBySeriesFugitive));

  const areaMaster = companyStore(useShallow((state) => state.dataArea));
  const getAllArea = companyStore(useShallow((state) => state.getAllArea));

  // const getAreaInCompany = utilsStore(useShallow((state) => state.getAreaInCompany));
  // const dataAreaInCompany = utilsStore(useShallow((state) => state.dataAreaInCompany));

  const getCompanyAreaDetail = companyStore(useShallow((state) => state.getCompanyAreaDetail));
  const dataCompanyAreaDetails = companyStore(useShallow((state) => state.dataCompanyAreaDetails));

  // console.log("dataCompanyAreaDetails", dataCompanyAreaDetails);
  // console.log("areaMaster", areaMaster);

  const getMasterLabel = (type: string, text: string, companyId?: string) => {
    if (!text || typeof text != "string") return "";
    if (type === "area" && areaMaster) {
      const resAreas = dataCompanyAreaDetails.find((item) => item.companyId === companyId)?.areas;
      if (resAreas) {
        const optValue = resAreas.find((item) => item._id === text);
        return optValue?.areaName;
      }
    } else if (type === "company") {
      const optValue = companies.find((item) => item._id === text);
      return optValue?.companyName;
    } else {
      return text;
    }
  };

  const onOpenModal = (mode: "insert" | "update", id: string) => {
    setMode(mode);
    setShowModal(true);
    if (id) {
      setSelectedId(id);
      const resultComBySeries = comBySeriesFugitive.find((item) => item._id === id);
      if (resultComBySeries) {
        const { companyId, areas } = resultComBySeries;
        const areaSeries = {
          areaSeries: [
            {
              _id: id,
              companyId,
              areas,
            },
          ],
        };
        if (areaSeries) {
          form.setFieldsValue(areaSeries);
        }
      }
    } else {
      form.setFieldsValue(initComBySeriesFugitive);
    }
  };

  const handleDelete = async (_id: string) => {
    try {
      setLoading(true);
      const response = await deleteComBySeriesFugitive(_id);
      if (response.data.code === 200) {
        setLoading(true);
        messageApi.open({
          type: "success",
          content: CommonSuccess.DELETE_SUCCESSFULL,
        });
        fetchComBySeriesFugitive();
      } else {
        setLoading(false);
        messageApi.open({
          type: "error",
          content: CommonError.SOMETHING_WRONG,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onSave = async (mode: "insert" | "update", data: AreaSeries) => {
    try {
      let response;
      setLoading(true);
      // console.log("data", data);
      // const dataUpdate = data.areaSeries.map((item) => {
      //   const { companyId } = item;
      //   return {
      //     _id: "",
      //     companyId,
      //   };
      // });
      response = await updateComBySeriesFugitive(data.areaSeries);
      // console.log("data.areaSeries", data.areaSeries);
      if (response?.data.code === 200) {
        setLoading(false);
        setShowModal(false);
        messageApi.open({
          type: "success",
          content: CommonSuccess.SAVED_SUCCESSFULL,
        });
        fetchComBySeriesFugitive();
      } else {
        setLoading(false);
        setIsDuplicate(false);
        messageApi.open({
          type: "error",
          content: CommonError.SOMETHING_WRONG,
        });
      }
    } catch (error) {
      // if (axios.isAxiosError(error)) {
      //   if (error?.response?.status === 409) {
      //     setIsDuplicate(true);
      //   } else {
      //     setIsDuplicate(false);
      //   }
      // }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onCloseModal = () => {
    setShowModal(false);
    setIsDuplicate(false);
    form.resetFields();
  };

  const showDeleteConfirm = async (value: SettingComBySeries) => {
    const { _id } = value;
    VocsModal.delete({
      onOk: async () => {
        if (_id) {
          handleDelete(_id);
        }
      },
    });
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;

    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }

    return queryParam;
  };

  const fetchComBySeriesFugitive = async () => {
    const query = createParamFilter();
    setLoading(true);
    await getComBySeriesFugitive(query);
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchComBySeriesFugitive()]);
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (comBySeriesFugitive?.length > 0) {
      const data: DataTableComBySeries[] = [];
      comBySeriesFugitive?.forEach((item) => {
        const { _id, areas, companyId } = item;
        areas?.forEach((itemArea: AreaSeriesDto) => {
          const { series, area } = itemArea;
          series?.forEach((itemSeries: Emission) => {
            const { series, bz, bd, edc, vcm } = itemSeries;
            data.push({
              _id: _id ?? "",
              companyId,
              area,
              series,
              bz,
              bd,
              edc,
              vcm,
            });
          });
        });
      });
      setDataTable(data);
    }
  }, [comBySeriesFugitive]);

  useEffect(() => {
    const fetchData = async () => {
      await getAllArea();
      await getCompanyAreaDetail();
    };
    setLoading(true);
    fetchData();
    setLoading(false);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchComBySeriesFugitive()]);
      setLoading(false);
    };
    fetchData();
  }, [current, filter]);

  const columns: TableProps<DataTableComBySeries>["columns"] = [
    {
      title: "Company",
      dataIndex: "companyId",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{getMasterLabel("company", text)}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1]._id !== record._id) {
          obj.props.rowSpan = dataTable.filter((item) => item._id === record._id && item.companyId === record.companyId).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Area",
      dataIndex: "area",
      render: (text, record, index) => {
        const obj = {
          children: <Text>{getMasterLabel("area", text, record.companyId)}</Text>,
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1]._id !== record._id || dataTable[index - 1].area !== record.area) {
          obj.props.rowSpan = dataTable.filter((item) => item._id === record._id && item.area === record.area).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
    },
    {
      title: "Series",
      dataIndex: "series",
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "%BZ",
      dataIndex: "bz",
      render: (text) => <Text>{formatNumberWithFillZero(text, 2)}</Text>,
    },
    {
      title: "%BD",
      dataIndex: "bd",
      render: (text) => <Text>{formatNumberWithFillZero(text, 2)}</Text>,
    },
    {
      title: "%EDC",
      dataIndex: "edc",
      render: (text) => <Text>{formatNumberWithFillZero(text, 2)}</Text>,
    },
    {
      title: "%VCM",
      dataIndex: "vcm",
      render: (text) => <Text>{formatNumberWithFillZero(text, 2)}</Text>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => {
        const obj = {
          children: (
            <Space>
              <Button
                className="border-transparent bg-transparent"
                disabled={!canEditTable(permissions)}
                onClick={() => {
                  onOpenModal("update", record._id);
                }}
              >
                <BsPencilSquare size={18} color={componentPalette.blueGrey} />
              </Button>
              <Button
                className="border-transparent bg-transparent"
                onClick={() => showDeleteConfirm(text)}
                disabled={!canEditTable(permissions)}
              >
                <BsTrashFill size={16} color={componentPalette.blueGrey} />
              </Button>
            </Space>
          ),
          props: {
            rowSpan: 1,
          },
        };
        if (index === 0 || dataTable[index - 1]._id !== record._id) {
          obj.props.rowSpan = dataTable.filter((item) => item._id === record._id).length;
        } else {
          obj.props.rowSpan = 0;
        }
        return obj;
      },
      align: "center",
    },
  ];

  const onChangePagination: PaginationProps["onChange"] = (page) => {
    setCurrent(page);
  };

  return (
    <div>
      {contextHolder}
      {form && (
        <FugitiveComBySeriesModal
          form={form}
          open={showModal}
          mode={mode}
          loading={loading}
          isDuplicate={isDuplicate}
          areaMaster={areaMaster}
          dataCompanyAreaDetails={dataCompanyAreaDetails}
          companies={companies}
          onDuplicateChange={(isDup) => {
            setIsDuplicate(isDup);
          }}
          // getAreaByCompany={(companyId) => getAreaByCompanyId(companyId)}
          onCloseModal={onCloseModal}
          onSave={(mode, data) => onSave(mode, data)}
        />
      )}
      {canEditTable(permissions) && (
        <div style={{ display: "flex", justifyContent: "end", paddingBottom: "10px" }}>
          <Button
            type="primary"
            size="middle"
            onClick={() => onOpenModal("insert", "")}
            style={{
              display: "flex",
              alignItems: "center",
            }}
            disabled={!canEditTable(permissions)}
          >
            <PlusCircleOutlined />
            New
          </Button>
        </div>
      )}
      <Table
        className="w-full"
        columns={columns}
        dataSource={dataTable}
        loading={loading}
        scroll={{ x: "max-content" }}
        pagination={false}
      />
      <Pagination
        size={"small"}
        showSizeChanger={false}
        style={{ display: "flex", justifyContent: "right", padding: "7px" }}
        current={current}
        total={totalComBySeriesFugitive}
        onChange={onChangePagination}
      />
    </div>
  );
};

export default FugitiveComBySeriesTable;
